export const CountryIds = {
  NO_COUNTRY: 0,
  USA: 1,
  CANADA: 2,
  PR: 3,
  BEL: 10,
  BRZ: 11,
  COLOMBIA: 15,
  CUBA: 18,
  CZE: 20,
  DR: 22,
  FRA: 25,
  GER: 26,
  GUAM: 29,
  ISR: 35,
  ITA: 36,
  JAPAN: 38,
  MEXICO: 41,
  NTH: 43,
  PANAMA: 48,
  SLO: 56,
  SPN: 59,
  SWZ: 62,
  UK: 65,
  USVI: 66,
  VEN: 67,
  AST: 69,
  BUL: 72,
};

export const TppCountries = [CountryIds.COLOMBIA, CountryIds.DR, CountryIds.PANAMA, CountryIds.VEN];

export const ShowcaseCountries = [
  CountryIds.BRZ,
  CountryIds.SPN,
  CountryIds.ITA,
  CountryIds.SLO,
  CountryIds.NTH,
  CountryIds.CZE,
  CountryIds.FRA,
  CountryIds.GER,
  CountryIds.ISR,
  CountryIds.BUL,
  CountryIds.AST,
  CountryIds.SWZ,
  CountryIds.BEL,
  CountryIds.UK,
];
